import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatDetail } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Session lives entirely in the httpOnly cookie. Probe /auth/me.
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatDetail(e?.response?.data?.detail || e.message) };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("Logout API failed:", e); }
    setUser(null);
  };

  const has = (_action) => !!user; // backend enforces
  const hasRole = (...roles) => !!user && user.roles?.some((r) => roles.includes(r));

  const pricingHidden = !!user?.pricing_hidden;
  const visibility = user?.visibility || { hide_modules: [], hide_fields: {} };
  const moduleHidden = (mod) => (visibility.hide_modules || []).includes(mod);
  const fieldHidden = (entity, field) => ((visibility.hide_fields || {})[entity] || []).includes(field);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, has, hasRole, pricingHidden, visibility, moduleHidden, fieldHidden }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
